// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Messages extends APIResource {
    /**
     * Get response messages associated with a run.
     */
    list(runID, query = {}, options) {
        return this._client.getAPIList(path `/v1/runs/${runID}/messages`, (ArrayPage), {
            query,
            ...options,
        });
    }
    /**
     * Retrieve Stream For Run
     */
    stream(runID, body = {}, options) {
        return this._client.post(path `/v1/runs/${runID}/stream`, {
            body,
            ...options,
            stream: true,
        });
    }
}
//# sourceMappingURL=messages.mjs.map